import { render } from "./Sidebar.vue?vue&type=template&id=b35921f6&scoped=true"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"

import "./Sidebar.vue?vue&type=style&index=0&id=b35921f6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b35921f6"

export default script